var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupplierIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 8.00065C14.6667 11.6825 11.6819 14.6673 8.00004 14.6673C4.31814 14.6673 1.33337 11.6825 1.33337 8.00065C1.33337 4.31875 4.31814 1.33398 8.00004 1.33398C11.6819 1.33398 14.6667 4.31875 14.6667 8.00065Z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4C8.5 3.72386 8.27613 3.5 8 3.5C7.72387 3.5 7.5 3.72386 7.5 4V4.21115C6.41305 4.40578 5.5 5.22241 5.5 6.33333C5.5 7.61147 6.70853 8.5 8 8.5C8.91767 8.5 9.5 9.1038 9.5 9.66667C9.5 10.2295 8.91767 10.8333 8 10.8333C7.08233 10.8333 6.5 10.2295 6.5 9.66667C6.5 9.39053 6.27614 9.16667 6 9.16667C5.72386 9.16667 5.5 9.39053 5.5 9.66667C5.5 10.7776 6.41305 11.5942 7.5 11.7889V12C7.5 12.2761 7.72387 12.5 8 12.5C8.27613 12.5 8.5 12.2761 8.5 12V11.7889C9.58693 11.5942 10.5 10.7776 10.5 9.66667C10.5 8.38853 9.29147 7.5 8 7.5C7.08233 7.5 6.5 6.8962 6.5 6.33333C6.5 5.77049 7.08233 5.16667 8 5.16667C8.91767 5.16667 9.5 5.77049 9.5 6.33333C9.5 6.60947 9.72387 6.83333 10 6.83333C10.2761 6.83333 10.5 6.60947 10.5 6.33333C10.5 5.22241 9.58693 4.40578 8.5 4.21115V4Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierIcon);
export default __webpack_public_path__ + "static/media/supplier-icon.2efc27b33cd33bf3749d9447a54a9105.svg";
export { ForwardRef as ReactComponent };